
import consult from '../images/treatment_consult.webp'
import acupunture from '../images/treatment_acupunture.webp'
import herbs from '../images/treatment_herbs.webp'
import cupping from '../images/treatment_cupping.webp'
import tuina from '../images/treatment_tuina.webp'
import moxi from '../images/treatment_moxi.webp'

import doctor_zh from '../images/doctor_zh.webp'
import doctor_dc from '../images/doctor_dc.webp'
import doctor_pm from '../images/doctor_pm.webp'

//#1A2238 #9DAAF2 #FF6A3D #F4DB7D
const Data = {
  theme: {
    colours: {
      primary: '#1A2238',
      primaryAlt1: '#9DAAF2',
      primaryAlt2: '#FF6A3D',
      primaryAlt3: '#F4DB7D',
      text: '#444',
      inverseText: 'white',
      background: 'white',
      backgroundAlt: '#f8f8fb',
      appBar: 'white'
    }
  },
  treatmentData: [
    {
      main: 'Consultations',
      sub: 'A full medical examinations related to the patients complaint and symptoms. ' +
        'This also includes discussion of possible treatment options.',
      image: consult,
    },
    {
      main: 'Acupuncture',
      sub: 'The insertion of very thin needles into specific points on the body. ' +
        'This is performed in accordance with diagnosis and traditional theories.',
      image: acupunture,
    },
    {
      main: 'Herbal Medicine',
      sub: 'The use of specific parts of plants with medicinal properties. ' +
        'This is based on the diagnosis of the practitioner in combination with traditional theories.',
      image: herbs,
    },
    {
      main: 'Cupping',
      sub: 'This involves using glass cups and a small amount of heat to create suction against the skin. ' +
        'This is done to promote healing in the body.',
      image: cupping,
    },
    {
      main: 'Tui Na',
      sub: 'This involves the use of a series of manipulations and therapeutic massage techniques to promote healing.',
      image: tuina,
    },
    {
      main: 'Moxibustion',
      sub: 'This involves burning a specific herb near the skin at specific points along the meridians. ' +
        'This creates heat in this area which helps the healing process.',
      image: moxi,
    },
  ],
  doctorData: [
    {
      name: 'Dr Zijing Hu',
      discipline: 'Chinese Medicine and Acupunture',
      contact: '074 826 2190',
      contactLink: 'tel:+27748262190',
      image: doctor_zh,
    },
    {
      name: 'Dr Darren Carpenter',
      discipline: 'Chinese Medicine and Acupunture',
      contact: '063 169 8802',
      contactLink: 'tel:+27631698802',
      image: doctor_dc,
    },
    {
      name: 'Ms Patricia Mbatha',
      discipline: 'Acupunture',
      contact: '084 604 2944',
      contactLink: 'tel:+27846042944',
      image: doctor_pm,
    },
  ],
  mediaData: [
    {
      title: 'Test Tiltle',
      details: 'Some details text here...',
      image: '',
    }
  ]
}

export default Data